<!--
    描述：注册用户页面
    Created by asq
-->
<template>
  <div class="h100 register-main">
    <!-- 列表查询页 -->
    <filter-layout
      @search="doSearch"
      @reset="resetSerach"
      v-if="!routeQuery"
      hasMore
	  :hasHeader="false"
    >
      <template #filter>
        <el-form
          class="flex-row-form colspan-4"
          size="small"
          ref="searchRef"
          label-width="100px"
          :model="searchForm"
        >
          <el-form-item label="个人账号：">
            <el-input
              :placeholder="'请输入'"
              size="small"
              v-model="searchForm.username"
              clearable
            >
            </el-input>
          </el-form-item>
          <el-form-item label="姓名：">
            <el-input
              :placeholder="'请输入'"
              size="small"
              v-model="searchForm.sname"
              clearable
            >
            </el-input>
          </el-form-item>
          <el-form-item label="手机号码：">
            <el-input
              :placeholder="'请输入'"
              v-model="searchForm.phone"
              size="small"
              clearable
            >
            </el-input>
          </el-form-item>
          <el-form-item label="账户状态：">
            <el-select v-model="searchForm.isFlag" size="small" clearable>
              <el-option :value="1" label="正常"></el-option>
              <el-option :value="0" label="停用"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
      <template #more>
        <el-form
          class="flex-row-form colspan-4"
          size="small"
          ref="searchRef"
          label-width="100px"
          :model="searchForm"
        >
          <el-form-item label="关联企业：">
            <el-input
              :placeholder="'请输入'"
              clearable
              size="small"
              v-model="searchForm.companyName"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="注册时间：" prop="dateArr" class="date-width">
            <el-date-picker
              v-model="searchForm.dateArr"
              type="daterange"
              clearable
              placeholder="请选择"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="是否实名：">
            <el-select v-model="searchForm.ralName" size="small" clearable>
              <el-option :value="0" label="未实名"></el-option>
              <el-option :value="1" label="已实名"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
      <template #content>
        <div class="content-header">
          <div class="title">
            合计注册用户：<span class="blue">{{ total }}</span> 个
          </div>
          <div class="btnGroups">
            <el-button
              type="primary"
              class="btn-blue"
              size="mini"
              @click="showTags('add')"
            >
              添加标签
            </el-button>
            <el-button
              type="primary"
              class="ml5 btn-blue"
              size="mini"
              @click="reFresh"
            >
              <i class="el-icon-refresh"></i>
            </el-button>
          </div>
        </div>
        <div class="w-table-layout w-table-page">
          <div class="w-table-content" v-show="tableShow">
            <el-table
              ref="xTable"
              :data="filterData"
              highlight-current-row
              height="100%"
              size="mini"
              @row-click="onRowClick"
              border
            >
              <el-table-column type="index" label="" width="50" align="center">
                <template slot-scope="scope">
                  <el-radio v-model="curRowId" :label="scope.row.id"></el-radio>
                </template>
              </el-table-column>
              <el-table-column
                type="index"
                label="序号"
                align="center"
                width="100"
              >
                <template slot-scope="scope">
                  <span class="text-right">{{
                    parseInt(scope.$index) + 1
                  }}</span>
                  <el-tooltip
                    :content="`标签：${scope.row.tags}`"
                    placement="right"
                    effect="light"
                    v-if="scope.row.tags && scope.row.tags !== ''"
                  >
                    <div slot="content" class="label-tooltip">
                      <el-tag
                        class="mr10 mb10"
                        size="mini"
                        v-for="(item, index) in toArray(scope.row.tags)"
                        :key="index"
                        >{{ item }}</el-tag
                      >
                    </div>
                    <svg-icon class="ml5" icon-class="biaoqian"></svg-icon>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                prop="username"
                label="账号"
                align="center"
                width="180"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="sname"
                label="姓名"
                align="center"
                width="180"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="idCard"
                label="身份证号码"
                align="center"
                width="180"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="phone"
                label="手机号码"
                align="center"
                width="130"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="createDate"
                label="注册时间"
                width="160"
                align="center"
                sortable
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="ralName"
                label="是否实名认证"
                width="150"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <div v-if="scope.row.isReal == '0'" class="no-real">
                    未实名
                  </div>
                  <div v-else-if="scope.row.isReal == '1'" class="real">
                    已实名
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="companyName"
                label="关联企业"
                min-width="200"
                header-align="center"
                sortable
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="isFlag"
                label="账户状态"
                width="120"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <div class="status">
                    <el-switch
                      class="switch"
                      v-model="scope.row.isFlag"
                      active-color="#2671cc"
                      inactive-color="#ddd"
                      active-text="启用"
                      inactive-text="关闭"
                      :active-value="1"
                      :inactive-value="0"
                      :class="{ opacityHide: !roleBtns.includes('enable') }"
                      disabled
                      @click.native.prevent="isFlagChange(scope.row)"
                    >
                    </el-switch>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" width="100">
                <template slot="header">操作</template>
                <template slot-scope="scope">
                  <el-button
                    type="primary"
                    size="small"
                    round
                    plain
                    class="table-btn"
                    v-if="roleBtns.includes('user-detail')"
                    @click="showDeatil(scope.row)"
                  >
                    <svg-icon icon-class="form-details"></svg-icon>
                    详情
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="w-table-footer">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="pageList"
              :page-size="pageSize"
              :total="total"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </div>
      </template>

      <!-- 标签弹窗 -->
      <el-dialog
        :visible.sync="tagsDialog.visible"
        class="primary-dialog"
        :width="tagsDialog.width"
        :title="tagsDialog.title"
        :close-on-click-modal="false"
        @closed="handleClosed"
        center
      >
        <!-- 当前选择标签 -->
        <el-row>
          <el-col :span="4" class="text-right row-label"
            ><span>当前选择标签</span></el-col
          >
          <el-col :span="20" class="tags-container">
            <el-tag
              v-for="(item, index) in selectedTags"
              :key="'selectTag' + index"
              effect="dark"
              size="small"
              class="mr5"
              closable
              @close="onTagRemove(item)"
              >{{ item.sname }}</el-tag
            >
          </el-col>
        </el-row>

        <!-- 新增时的 输入框 -->
        <el-row class="mt5">
          <el-col :span="20">
            <el-input
              v-model="newTagName"
              placeholder="输入新的标签"
              :maxlength="15"
              show-word-limit
            ></el-input>
          </el-col>
          <el-col :span="4" class="text-right pdl10">
            <el-button class="btn-blue row-btn" @click="addNewTag"
              >保存</el-button
            >
          </el-col>
        </el-row>

        <!-- 全部标签 -->
        <div class="mt5 tags-all-container">
          <el-tag
            v-for="(item, index) in allTags"
            :key="'allTags' + index"
            :effect="item.isChoose === 1 ? 'dark' : 'plain'"
            class="mr5"
            size="small"
            @click="onTagSelected(item)"
            >{{ item.sname }}</el-tag
          >
        </div>

        <!-- footer 组件 -->
        <div slot="footer" class="dialog-footer text-center">
          <el-button
            class="btn"
            size="small"
            @click="tagsDialog.visible = false"
            >取 消</el-button
          >
          <el-button
            type="primary"
            size="small"
            class="btn btn-blue"
            :loading="btnLoading"
            @click="doTagsSave"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </filter-layout>
    <div v-else class="h100">
      <UserDetails :rowData="rowData"></UserDetails>
    </div>
  </div>
</template>
<script>
import {
	getObjectTags,
	saveObjectTags,
	selectUserPage,
	updateUser
} from "api/modules/registeredUser_new";
import { mapState } from "vuex";

import UserDetails from "./components/UserDetails";

export default {
  name: "Registered-user",
  components: {
    UserDetails,
  },
  data() {
    return {
      //状态选择器
      options: [
        {
          value: 1,
          label: "正常",
        },
        {
          value: 0,
          label: "停用",
        },
      ],
      // 标签相关
      btnLoading: false,
      curRowId: "",
      tagsDialog: {
        visible: false,
        width: "800px",
        title: "添加标签",
        type: "",
      },
      originalTags: [], // 初始选择的标签（做最后对比）
      selectedTags: [], // 当前选择标签
      publicTags: [], // 公共标签
      personalTags: [], // 个人历史标签
      allTags: [], // 所有标签（不再显示说明）
      newTagName: "", // 输入的标签名称
      //选中账户状态
      status2: "",
      filterData: [],
      searchForm: {
        username: "",
        sname: "",
        phone: "",
        ralName: "",
        isFlag: "",
        startTime: "",
        endTime: "",
      },
      newAccount: {
        sname: "",
        idCard: "",
        phone: "",
        email: "",
        username: "",
        password: "",
      },
      loading: false,
      //筛选框
      auditState: "",
      currentPage: 1, // 当前页码
      pageList: [10, 20, 50, 100], // 显示条数数组
      pageSize: 10, // 当前显示条数
      total: 0, // 当前总条数
      dialogData: {},
      companyList: [],
      searchToggle: true,
      tableShow: true,

      startDatePicker: this.beginDate(),
      endDatePicker: this.processDate(),
      rowData: {},
    };
  },
  created() {
    if (this.$getSessionItem("registerUserParams")) {
      this.searchForm = JSON.parse(this.$getSessionItem("registerUserParams"));
      this.currentPage = JSON.parse(
        this.$getSessionItem("registerUserParams")
      ).current;
      this.pageSize = JSON.parse(
        this.$getSessionItem("registerUserParams")
      ).size;

      // 移除 避免污染
      this.$removeSessionItem("registerUserParams");
    }
    this.getData();
  },
  methods: {
    //重置筛选框
    resetSerach() {
      this.currentPage = 1;
      this.pageSize = 10;
      this.searchForm = {};
      this.getData();
    },

    //条件查询
    doSearch() {
      this.currentPage = 1;
      this.pageSize = 10;
      this.getData();
    },

    //刷新
    reFresh() {
      this.searchForm = {};
      this.getData();
    },

    // 行点击事件
    onRowClick(row) {
      this.curRowId = row.id;
    },
    // 展示标签
    toArray(str) {
      let arr = str.split(",").filter((x) => x !== "");
      return arr;
    },
    // 弹窗关闭
    handleClosed(needRefresh) {
      this.originalTags = [];
      this.selectedTags = [];
      this.publicTags = [];
      this.personalTags = [];

      this.tagsDialog.visible = false;
      this.tagsDialog.type = "";

      // 刷新
      needRefresh ? this.getData() : "";
    },

    // 展示标签弹窗
    showTags(type) {
      if (this.curRowId === "") {
        this.$message.warning("请先选择要添加标签的用户！");
        return;
      }
      this.tagsDialog.visible = true;
      this.tagsDialog.type = type;
      switch (type) {
        case "add":
          // 新增
          let params = {
            objectId: this.curRowId,
            applys: "1001025001002",
            busUnit: "1001025001",
            createUserid: this.userInfo.id,
          };
          getObjectTags(params)
            .then((res) => {
              // 已选择标签
              this.originalTags = JSON.parse(
                JSON.stringify(res.data.privateExsitTags)
              );
              this.selectedTags = res.data.privateExsitTags;

              // 公共标签
              this.publicTags = res.data.platTags;

              // 个人历史标签
              this.personalTags = res.data.privateTags;

              // 所有标签集合
              this.allTags = [...res.data.platTags, ...res.data.privateTags];
            })
            .catch((err) => {});
          break;
        case "view":
          break;
      }
    },
    // 标签选择
    onTagSelected(item) {
      // console.log(item)
      // 选中状态
      item.isChoose = item.isChoose === 1 ? 0 : 1;

      // 选中标签数组
      if (item.isChoose === 1) {
        this.selectedTags.push(item);
      } else {
        let index = this.selectedTags.findIndex((x) => x.tagId === item.tagId);

        if (index > -1) {
          this.selectedTags.splice(index, 1);
        }
      }
    },
    // 选中标签删除
    onTagRemove(item) {
      // 如果不是 新增的标签
      if (item.tagId !== "") {
        let _index = this.allTags.findIndex((x) => x.tagId === item.tagId);
        if (_index > -1) {
          this.allTags[_index].isChoose = 0;
        }
      }

      // 选中数组移除
      this.selectedTags.splice(this.selectedTags.indexOf(item), 1);
    },

    // 保存输入的标签
    addNewTag() {
      let value = this.newTagName.replace(/\s+/, "");
      if (value && value !== "") {
        // 再判断标签 是否已存在
        let _item = this.allTags.find((x) => x.sname === value);

        if (_item) {
          switch (_item.isChoose) {
            case 1:
              this.$message.info("该标签已选择！");
              break;
            default:
              _item.isChoose = 1;
              this.selectedTags.push(_item);
          }
        } else {
          let params = {
            id: "",
            tagId: "",
            sname: value,
            type: "0",
            isChoose: 1,
          };
          this.selectedTags.push(params);
        }

        this.newTagName = "";
      } else {
        this.$message.warning("请输入要保存的标签！");
      }
    },

    // 标签弹窗保存
    doTagsSave() {
      this.btnLoading = true;
      let params = {
        objectId: this.curRowId,
        objectName: this.curRowName,
        applys: "1001025001002",
        busUnit: "1001025001",
        createUserid: this.userInfo.id,
        createUser: this.userInfo.sname,
        addTags: this.selectedTags,
        deleteTags: [],
      };

      // 新增、删除标签数组处理
      this.originalTags.map((x) => {
        let _item = this.selectedTags.find((y) => y.id === x.id);
        if (!_item) {
          params.deleteTags.push(x);
        }
      });
      params.addTags = this.selectedTags.filter((x) => !x.id || x.id === "");

      if (params.addTags.length === 0 && params.deleteTags.length === 0) {
        this.$message.warning("请操作后保存！");
        setTimeout(() => {
          this.btnLoading = false;
        }, 2000);
        return;
      }

      // 执行保存接口
      saveObjectTags(params)
        .then((res) => {
          if (res.operationCode === 1) {
            this.$message.success("保存成功!");
            setTimeout(() => {
              this.btnLoading = false;
              this.handleClosed(true);
            }, 2000);
          }
        })
        .catch((err) => {
          setTimeout(() => {
            this.btnLoading = false;
          }, 2000);
        });
    },
    //获得列表数据
    getData() {
      if (this.searchForm.dateArr && this.searchForm.dateArr.length > 0) {
        this.searchForm.startTime = this.searchForm.dateArr[0] + " 00:00:00";
        this.searchForm.endTime = this.searchForm.dateArr[1] + " 23:59:59";
      } else {
        this.searchForm.startTime = "";
        this.searchForm.endTime = "";
      }
      let params = Object.assign({}, this.searchForm);
      this.loading = true;
      // 分页参数
      params.current = this.currentPage;
      params.size = this.pageSize;

    //   params.startTime = params.startTime ? params.startTime + " 00:00:00" : "";
    //   params.endTime = params.endTime ? params.endTime + " 23:59:59" : "";
      selectUserPage(params)
        .then((res) => {
          this.loading = false;
          this.filterData = res.data.pageData.records;
          this.currentPage = parseInt(res.data.pageData.current);
          this.total = parseInt(res.data.pageData.total);
          this.pageSize = parseInt(res.data.pageData.size);
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    //筛选框重置
    handleClose() {
      this.dialogObj.visible = false;
    },

    //查看账号详情
    showDeatil(params) {
      let param = this.$utils.clone(this.searchForm, true);
      param.current = this.currentPage;
      param.size = this.pageSize;

      // 存值
      this.$setSessionItem("registerUserParams", JSON.stringify(param));
      this.rowData = params;
      this.$router.push({
        path: "/registered-user-new",
        query: {
          type: "view",
        },
      });
    },

    //修改状态
    editStatus(params) {
      this.dialogObj.visible = true;
      this.dialogObj.title = "修改状态";
      this.dialogObj.width = "400px";
      this.dialogData = params;
      this.dialogObj.mode = "editStatus";
      this.status2 = params.status;
    },

    // 切换显示条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },

    //切换当前页码
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData();
    },

    // 是否展开搜索区域
    changeState() {
      this.searchToggle = !this.searchToggle;
    },

    // 登录账号提示
    alertMsg() {
      if (this.newAccount.phone == "") {
        this.$message.info("登录账号默认为手机号，请填写手机号！");
      }
    },

    // 开始时间的 pickOption
    beginDate() {
      let that = this;
      return {
        disabledDate(time) {
          let endTime = "";
          endTime = that.searchForm.endTime;
          if (endTime) {
            return bmElementTimeOptins.limitDateBefore(time, endTime, true);
          } else {
            return time.getTime() > Date.now();
          }
        },
      };
    },

    // 结束时间的 pickOption
    processDate() {
      let that = this;
      return {
        disabledDate(time) {
          let startTime = "";
          startTime = that.searchForm.startTime;
          if (startTime) {
            let nowTime = Date.now();
            return bmElementTimeOptins.limitDateInRange(
              time,
              startTime,
              nowTime,
              true
            );
          } else {
            return time.getTime() > Date.now();
          }
        },
      };
    },

    isFlagChange(row) {
      if (this.roleBtns.includes("enable")) {
        this.$confirm("是否确认改变用户状态?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            row.isFlag == 0 ? (row.isFlag = 1) : (row.isFlag = 0);
            let param = { id: row.id, isFlag: row.isFlag };
            updateUser(param).then((res) => {
              if (res.operationCode == 1) {
                this.$message.success("修改成功");
                this.getData();
              }
            });
          })
          .catch(() => {
            this.$message.info("操作取消");
          });
      } else {
        this.$message.warning("当前账号没权限进行此操作！");
      }
    },
  },
  computed: {
    ...mapState("menu", {
      roleBtns: (state) => state.roleBtns,
    }),
    routeQuery() {
      return this.$route.query.type;
    },
    // 当前选择的 用户名称
    curRowName() {
      if (this.curRowId === "") {
        return "";
      }

      let _item = this.filterData.find((x) => x.id === this.curRowId);
      if (_item) {
        return _item.account;
      }

      return "";
    },
    ...mapState("user", {
      userInfo: (state) => state.userInfo,
    }),
  },
  watch: {
    // 监听 筛选元素的 切换展示 重新调整表格高度
    searchToggle() {
      this.tableShow = false;
      setTimeout(() => {
        this.tableShow = true;
      }, 50);
      setTimeout(() => {
        this.$refs.xTable.doLayout();
      }, 1000);
    },
  },
};
</script>

<style lang="less" scoped>
.register-main {
  .content-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    .title {
      padding-left: 10px;
      border-left: 4px solid #2671cc;
      font-size: 14px;
      color: #202020;
    }
    .blue {
      font-size: 18px;
      color: #2671cc;
    }
  }

  .filter-box {
    padding-top: 5px;
  }

  /deep/ .search-form {
    .el-form-item {
      margin-bottom: 5px;
    }
  }

  .blue-text {
    color: #2671cc;
    cursor: pointer;
  }

  .blue-text:hover {
    color: blue;
  }

  .el-switch.is-disabled {
    opacity: 1;
  }

  /deep/ .el-switch.is-disabled .el-switch__core,
  /deep/ .el-switch.is-disabled .el-switch__label {
    cursor: pointer !important;
  }
}
.w-table-content {
  /deep/ .el-radio__label {
    display: none;
  }
}
.label-tooltip {
  max-width: 600px;
  max-height: 140px;
  overflow-y: auto;
  overflow-x: hidden;
}

.primary-dialog {
  /deep/ .el-dialog__body {
    padding: 30px;
  }

  .row-label {
    height: 40px;
    line-height: 40px;
    padding-right: 15px;
  }

  .row-btn {
    padding-left: 10px;
    width: 100%;
  }

  .tags-container {
    line-height: 40px;
    max-height: 120px;
    overflow-y: auto;

    /deep/ .el-tag {
      cursor: pointer;
    }
  }

  .tags-all-container {
    line-height: 30px;
    max-height: 300px;
    overflow-y: auto;

    /deep/ .el-tag {
      cursor: pointer;
    }
  }
}
.pd10 {
  padding: 0 5px;
}
</style>

<style lang="less">
.status {
  .switch > .el-switch__label--right > span {
    margin-left: 0 !important;
    margin-right: 15px !important;
  }
}
</style>
  .switch > .el-switch__label--right > span {
    margin-left: 0 !important;
    margin-right: 15px !important;
  }
}
</style>
